/**
 * DAWRightRail — the right-side column of the studio (Master Bus,
 * AI Voice Clone, Stem Extractor, Effects Rack). Extracted from
 * ELPMStudioDAW during the iter-178 refactor.
 *
 * This is a pure passthrough container — it owns no state, just
 * groups the cards so the main file's render block is shorter and
 * the rail can be repositioned/wrapped together in the future.
 */
import MasterBusCard from "@/components/daw/MasterBusCard";
import { VoiceCloneCard, StemExtractorCard, EffectsRackCard } from "@/components/daw/SideCards";

export default function DAWRightRail(props) {
  const {
    // MasterBusCard
    masterVol, ceiling, masterPeak,
    onVolChange, onCeilingChange,
    onMaster, onMasterAndBounce,
    masterBusy, masteringStats, masteringTarget, onTargetChange, onMasteringReset,
    // VoiceCloneCard
    onVoiceOpen, voiceCount,
    // StemExtractorCard
    selectedChannel, selectedChannelHasAudio, firstChannelWithAudio,
    onStemExtract, onStemLoadAudio, onStemDropAudio, stemBusy,
    lastExtractionCount, lastExtractionSongName, onDownloadStemPack, onPublishStemPack,
    // EffectsRackCard
    selectedFx, fxParams, onToggleFx, onParamChange, onLoadPreset,
    automationArmed, automationSummary, automationLanes,
    enginePlaying, onToggleAutomationArm, onClearAutomation, onClearLaneParam,
    sidechainState, channelsWithAudio, onSidechainChange,
  } = props;

  return (
    <aside className="space-y-4">
      <MasterBusCard
        masterVol={masterVol}
        ceiling={ceiling}
        masterPeak={masterPeak}
        onVolChange={onVolChange}
        onCeilingChange={onCeilingChange}
        onMaster={onMaster}
        onMasterAndBounce={onMasterAndBounce}
        busy={masterBusy}
        masteringStats={masteringStats}
        masteringTarget={masteringTarget}
        onTargetChange={onTargetChange}
        onMasteringReset={onMasteringReset}
      />
      <VoiceCloneCard onOpen={onVoiceOpen} voiceCount={voiceCount} />
      <StemExtractorCard
        selectedChannel={selectedChannel}
        selectedChannelHasAudio={selectedChannelHasAudio}
        firstChannelWithAudio={firstChannelWithAudio}
        onExtract={onStemExtract}
        onLoadAudio={onStemLoadAudio}
        onDropAudio={onStemDropAudio}
        busy={stemBusy}
        lastExtractionCount={lastExtractionCount}
        lastExtractionSongName={lastExtractionSongName}
        onDownloadPack={onDownloadStemPack}
        onPublishPack={onPublishStemPack}
      />
      <EffectsRackCard
        selectedChannel={selectedChannel}
        selectedFx={selectedFx}
        fxParams={fxParams}
        onToggle={onToggleFx}
        onParamChange={onParamChange}
        onLoadPreset={onLoadPreset}
        automationArmed={automationArmed}
        automationSummary={automationSummary}
        automationLanes={automationLanes}
        enginePlaying={enginePlaying}
        onToggleAutomationArm={onToggleAutomationArm}
        onClearAutomation={onClearAutomation}
        onClearLaneParam={onClearLaneParam}
        sidechainState={sidechainState}
        channelsWithAudio={channelsWithAudio}
        onSidechainChange={onSidechainChange}
      />
    </aside>
  );
}
